import { useCallback, useState } from 'react';
import { Questao } from '../../sdk/@types';
import QuestaoService from '../../sdk/services/QuestaoService';

export default function useQuestao() {
  const [questao, setQuestao] = useState<Questao.Questao>({
    testingAgencyId: '',
    subjectId: '',
    difficulty: 'FACIL',
    choices: [
      {
        correct: true,
      },
      {
        correct: false,
      },
      {
        correct: false,
      },
      {
        correct: false,
      },
    ],
  });

  const [questoes, setQuestoes] = useState<Questao.Questao[]>([]);

  const newQuestion = useCallback(() => {
    setQuestao({
      testingAgencyId: '',
      subjectId: '',
      difficulty: 'FACIL',
      choices: [
        {
          correct: true,
        },
        {
          correct: false,
        },
        {
          correct: false,
        },
        {
          correct: false,
        },
      ],
    });
  }, []);
  
  const fetchQuestao = useCallback((questaoId: number) => {
    QuestaoService.getQuestao(questaoId);
  }, []);

  const tags = useCallback(() => {
    QuestaoService.buscarTagBancaAnoMateria();
  }, []);

  const fetchQuestoesPorFiltro = useCallback(async (query: Questao.QuestionFilterByQuery) => {
    try {
      const questoesReturned = await QuestaoService.getQuestoesPorFiltro(query);
      setQuestoes(questoesReturned ?? []);
    } catch {
      setQuestoes([]);
    }
  }, []);

  return {
    questao,
    questoes,
    newQuestion,
    setQuestao,
    setQuestoes,
    fetchQuestao,
    fetchQuestoesPorFiltro,
    tags,
  };
}
